import { useFind } from 'api/APIHooks';
import { isTypeSerializable } from 'api/utils/isTypeSerializable';
import Notifier from 'common/helpers/Notifier';

export const useFindFileUploads = (recordType, recordId) => {
  if (!isTypeSerializable(recordType)) throw new Error('Invalid RecordType for useFindFileUploads');

  const { data, isLoading, isSuccess } = useFind(
    'file_upload',
    { record: recordId, 'record.type': recordType },
    {
      queryConfig: {
        enabled: !!recordId,
        placeholderData: undefined,
        onError: () => Notifier.dispatch('error', 'Failed to load files'),
      },
    },
  );

  return { fileUploads: data?.data?.data ?? [], isLoading, isSuccess };
};
